import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    standalone: false,
    selector: 'app-create-form-dialog',
  templateUrl: './create-form-dialog.component.html',
  styleUrls: ['./create-form-dialog.component.scss']
})
// *Title, *Country: Country, Entity Name: TextBox, *Category: [Custom]->dropdown, Type: TexBox, Form No : TextBox, *Select View Type: [Page, Collapsable]->dropdown
export class CreateFormDialogComponent implements OnInit {
  inputForm:  FormGroup
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public matDialogReference:  MatDialogRef<CreateFormDialogComponent>, private formBuilder: FormBuilder)
   { 
    this.inputForm = this.formBuilder.group({
      title: new FormControl('',[Validators.required]), 
      country: new FormControl('', [Validators.required]),
      entityName: new FormControl(''),
      category: new FormControl(''),
      formNo: new FormControl(''),
      viewType: new FormControl('',[Validators.required])
    });
   }

  ngOnInit(): void {
    this.initForm()
  }
  initForm(){
     this.inputForm.controls['category'].setValue('Custom');
     this.inputForm.controls['viewType'].setValue('Page');
  }
  onSubmitForm()
  {
    let country = this.inputForm.controls['country'].value;
    const formInput = {
      title: this.inputForm.controls['title'].value,
      countryName: country.name,
      countryCode: country.code,
      entityName: this.inputForm.controls['entityName'].value,
      category: this.inputForm.controls['category'].value,
      formNo: this.inputForm.controls['formNo'].value,
      viewType: this.inputForm.controls['viewType'].value
    }
    this.matDialogReference.close({status:'Ok' , data: formInput});
  }
  closeDialog(){
    this.matDialogReference.close({status: 'Cancel'});
  }

}
